import { VStack, Heading, useToast, Center } from "@chakra-ui/react";
import ClawMachinePrizeForm from "./Form";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../consts/routes";
import { LevelRewardFormData } from "@olagg/validation-schemas";
import useLevelRewards from "./hooks/useLevelRewards";

const CreateLevelReward = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { createLevelReward } = useLevelRewards();

  const onSubmit = async (dataForm: LevelRewardFormData) => {
    try {
      await createLevelReward(dataForm);
      toast({
        title: 'Premio por Nivel',
        colorScheme: 'olaggPink',
        status: 'success',
        description: `Premio creado con éxito`,
        position: 'bottom-right'
      });
      navigate(ROUTES.LEVEL_REWARDS.all);
    } catch (error: any) {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: error.message || 'Error al crear el premio',
        position: 'bottom-right'
      });
    }
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Premio</Heading>
        <ClawMachinePrizeForm onSubmit={onSubmit} />
      </VStack>
    </Center>
  );
};

export default CreateLevelReward;